import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";

const NOTIFICATIONS_URL = "/services/notification/";
// function checkNotificationsChanged(oldNotifications, newNotifications) {
//   if (!oldNotifications) return false;

//   const newIds = new Set(map(newNotifications, (x) => x.notificationId));
//   const oldIds = new Set(map(oldNotifications, (x) => x.notificationId));

//   return newIds.size > oldIds.size;
// }
export function* notificationRequest() {
  yield takeLatest(CONSTANTS.GET_NOTIFICATIONS_MAIN, function* (action) {
    const calledFromHub = action.payload;
    // const currentNotifications = yield select(
    //   (state) => state.common.notifications
    // );
    try {
      // if called from hub dont show loading
      if (!calledFromHub) {
        yield put(actions.setNotifications(null));
      }

      const getAllNotifications = false;
      const url = `${NOTIFICATIONS_URL}GetNotifications/${getAllNotifications}`;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      const data = res.data;

      const error = {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage,
      };

      if (!res.success) throw error;

      // const notificationsChanged = yield checkNotificationsChanged(
      //   currentNotifications,
      //   data
      // );
      // if (notificationsChanged) {
      //   const toastId = "new-notifications-success";
      //   const message = yield formatByIdSaga("topbar.NewNotification");
      //   toast(message, { toastId });
      // }

      yield put(actions.setNotifications(data));
    } catch (e) {
      console.error(e);
      // const toastId = "load-notifications-error";
      // const message = yield formatByIdSaga("topbar.CouldNotLoadNotifications");
      // toast(message, { toastId });
      // if called from hub dont empty on error
      if (!calledFromHub) {
        yield put(actions.setNotifications([]));
      }
    }
  });
}
export function* readNotification() {
  yield takeLatest(CONSTANTS.READ_NOTIFICATION_MAIN, function* (action) {
    const { notificationId, callbackActions } = action.payload;

    try {
      const url = `${NOTIFICATIONS_URL}MarkAsReadNotification/${notificationId}`;
      const res = yield window.mainAxios.put(url).then((r) => r.data);

      const error = {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage,
      };

      if (!res.success) throw error;

      // MOCK
      // yield delay(1000);
      // yield put(actions.setNotifications([]))

      // if successfuly read notification
      // dispatch callback actions
      // request new notifications
      yield all(callbackActions.map((action) => put(action)));
      yield put(actions.getNotifications());
    } catch (e) {
      // console.log(e);
      // const toastId = 'read-notifications-error';
      // const message = yield formatByIdSaga('topbar.CouldNotReadNotification');
      // toast(message, { toastId });
    }
  });
}

export default function* notificationsSaga() {
  yield all([fork(notificationRequest), fork(readNotification)]);
}
